import React from 'react';
import { Navigate } from 'react-router-dom';
import { Server } from '../../server/server';
import { getPortraitImage } from '../util/user';
import './NotificationsPage.css'
import AlertModal from '../modals/AlertModal';
import { BsExclamationCircleFill, BsFillCircleFill, BsStarFill } from 'react-icons/bs';
import PageEnvelope from '../elements/PageEnvelope';
import Portrait from '../elements/Portrait';

function White({children}) {
  return <span style={{color: 'white'}}>{children}</span>;
}

interface NotificationsPageState {
  notifications: any[];
  navigate: string;
  loading: boolean;
  loadingMoreBlogs: boolean;
  noMoreBlogs: boolean;
  lastRead: Date;
  alert: string;
}

class NotificationsPage extends React.Component<{}, NotificationsPageState> {

  constructor(props: any) {
    super(props);

    this.state = {
      notifications: [],
      navigate: '',
      loading: false,
      loadingMoreBlogs: false,
      noMoreBlogs: false,
      lastRead: null,
      alert: ''
    }

    this.onNotification = this.onNotification.bind(this);
  }

  componentDidMount() {
    Server.notifications.addEventListener('notification', this.onNotification);
    let cookie = Server.user.getCookie('last-notification-read');
    if(cookie)
      this.setState({lastRead: new Date(cookie)});
    this.getNotifications();
  }

  componentWillUnmount() {
    Server.notifications.removeEventListener('notification', this.onNotification);
  }

  async getNotifications() {
    this.setState({loading: true});

    let messages = Server.notifications.getMessages();

    if(messages.length > 0) {
      let cookie = Server.user.getCookie('last-notification-read');
      if(cookie != messages[0].date)
        Server.user.setCookie({key: 'last-notification-read', value: messages[0].date});
    }

    // cache profiles
    let profiles = [];
    for (let i = 0; i < messages.length; i++) {
      if(messages[i].user && profiles.indexOf(messages[i].user) == -1)
        profiles.push(messages[i].user);
    }

    await Server.public.loadProfiles(profiles);

    this.setState({notifications: messages, loading: false});
  }

  onNotification(data: any) {
    this.getNotifications();
  }

  async onLoadMore() {
    this.setState({loadingMoreBlogs: true});
    await Server.notifications.loadMoreMessages();
    this.getNotifications();
    this.setState({loadingMoreBlogs: false});
  }

  onMessageClick(msg:any) {
    switch(msg.type) {
      case 'blog-comment':
        this.setState({navigate: '/blog/' + msg.slug})
        break;      
      case 'forum-post':
        this.setState({navigate: `/forum/${msg.forum}/${msg.topic}`})
        break;      
      case 'post-like':
      case 'post-reply':
      case 'post-reply-reply':
      case 're-post':
        this.setState({navigate: '/activity/post/' + msg.post})
        break;      

      case 'follow':
      case 'unfollow':
      case 'friend-accept':
      case 'friend-decline':
      case 'friend-remove':
        let profile = Server.public.getProfile(msg.user);
        if(profile)
          this.setState({navigate: `/profile/${profile.slug}`})
        break;      
    }
  }

  renderNotifications() {
    if(this.state.loading) 
      return (<div>Loading...</div>); 

    let divs = [];
    for (let i = 0; i < this.state.notifications.length; i++) {
      let notification = this.state.notifications[i];

      let user = null;
      if(notification.type == 'event-win')
        user = Server.user.getProfile();
      else
        user = Server.public.getProfile(notification.user);

      let userName = user ? user.name : 'Deleted User';
      if(notification.type == 'event-win')
        userName = 'You';

      // parse the content of notification
      let title = '';
      let content = '';

      switch(notification.type) {
        case 'post-like':
          title = 'liked your activity';
          content = notification.content;
          break;
        case 'post-reply':
          title = 'replied to your activity';
          content = `"${notification.content}"`;
          break;
        case 'post-reply-reply':
          title = 'replied to activity you also replied to';
          content = `"${notification.content}"`;
          break;
        case 're-post':
          title = 'reposted your activity';
          content = notification.content;
          break;
        case 'forum-post':
          title = 'posted in your forum topic';
          content = `"${notification.post}"`;
          break;
        case 'blog-comment':
          title = 'commented your blog';
          content = `"${notification.comment}"`;
          break;
        case 'friend-accept':
          title = 'accepted your friend request';
          break;
        case 'friend-decline':
          title = 'declined your friend request';
          break;
        case 'friend-remove':
          title = 'is no longer your friend';
          break;
        case 'follow':
          title = 'followed you';
          break;
        case 'unfollow':
          title = 'stopped following you';
          break;
        case 'user-joined':
          title = ' has joined your community';
          break;
        case 'site-invite-accept':
          title = ' has accepted your invitation and joined the community';
          break;
        }

      let unread = true;
      if(this.state.lastRead) {
        let msgDate = new Date(notification.date);
        unread = msgDate > this.state.lastRead;
      }

      divs.push(
        <div key={i} className="site-page-panel" style={{rowGap: '0px', cursor: 'pointer'}} onClick={()=>this.onMessageClick(notification)}>
          <div className="site-page-row" style={{justifyContent: 'space-between'}}>
            <div style={{display: 'grid', gridTemplateColumns: 'auto 1fr 15px', alignItems: 'center'}}>
              {user && 
                <Portrait user={user.id} />
              }
              <div style={{marginLeft: '8px'}}>
                <div><b>{userName}</b> {title}</div>
                {content != '' &&
                  <div className="site-page-subtext" style={{marginLeft: '10px', marginTop:'5px'}}>{content}</div>
                }
              </div>
            </div>
            {unread && 
              <div className="site-page-notify-circle">
                <BsExclamationCircleFill size="1.4em" />
              </div>
            }
          </div>
          {/* {notification.type == 'gift-sent' &&
            <div style={{marginTop: '8px'}}>
              <AssetPanel asset={Server.assets.getAsset(notification.asset)} quantity={notification.quantity} />
            </div>
          } */}
        </div>
      );
    }

    return divs.length > 0 
      ? <div style={{display: 'flex', flexDirection: 'column', rowGap: '10px'}}>
          {divs}

          {!this.state.loading && !this.state.noMoreBlogs &&
            <div style={{marginTop: '15px'}}>
              <button
                onClick={()=>this.onLoadMore()}
                disabled={this.state.loadingMoreBlogs}
              >
                {this.state.loadingMoreBlogs ? 'Loading...' : 'Load More'}
              </button>
            </div>
          }
        </div>
      : <div>No Notifications yet.</div>
  }

  render() {
    if(!Server.account.isLoggedIn())
      return(<Navigate replace to="/" />);

    if(this.state.navigate != '')
      return <Navigate to={this.state.navigate} />;

    return (
      <div className="site-page">
        <PageEnvelope width="500px">
          {this.state.loading ? 
            <div className="site-page-panel">Loading...</div> : 
            this.renderNotifications()
          }
        </PageEnvelope>
        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})}/>
      </div>
    )
  }
}

export default NotificationsPage;